import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal, Row, Col, InputGroup } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import { Create } from "../../../utils/apis/agentManagement/master/index";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import Loader from "react-js-loader";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";

// Import Bootstrap Icons (make sure Bootstrap Icons are linked in your index.html)
import { Eye, EyeSlash } from "react-bootstrap-icons"; // Recommended

function Add(props) {
  const { UnauthorizedLogOut } = useContext(Context);

  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [shimmerLoader, setShimmerLoader] = useState(false);

  // Password visibility states
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    getValues,
    setValue,
  } = useForm();

  const imageFile = watch("image");
  const clientShare = watch("share");

  useEffect(() => {
    if (clientShare) {
      setValue("your_share", 100 - Number(clientShare));
    }
  }, [clientShare, setValue]);

  const onSubmit = async (data) => {
    setShimmerLoader(true);
    try {
      const sendData = new FormData();

      sendData.append("contact_no", data.contact_no);
      sendData.append("email", data.email);
      sendData.append("password", data.password);
      sendData.append("c_password", data.c_password);
      sendData.append("share", data.share);
      sendData.append("your_share", data.your_share);

      const response = await Create(sendData);

      if (response?.data?.code === HTTPS.CREATED.code) {
        setShimmerLoader(false);
        setShowModal({
          code: response.data.code,
          message: response.data.data || "Added successfully!",
        });

        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          props.onHide();
          reset();
        }, 2000);
      } else {
        setShimmerLoader(false);
        setError("name", {
          type: "manual",
          message: response?.data?.errors || "Something went wrong",
        });
      }
    } catch (error) {
      setShimmerLoader(false);
      setError("name", {
        type: "manual",
        message: error?.response?.data?.errors || "An error occurred",
      });
      await UnauthorizedLogOut(error);
      console.error(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        className="Edit_User_Modal modal_holder"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal_Heading modalHeading="Add Master" />
        <Modal.Body>
          <div className="main-form-holder">
            <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
              <Row>
                {/* Contact No */}
                <Col md={6}>
                  <Form.Group className="main-form-section mt-3">
                    <Form.Label>Contact No</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Enter Contact No"
                        {...register("contact_no", {
                          required: "Contact No is required",
                          minLength: {
                            value: 10,
                            message: "Must be 10 digits",
                          },
                          maxLength: {
                            value: 10,
                            message: "Must be 10 digits",
                          },
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Contact No must be 10 digits",
                          },
                        })}
                        maxLength={10}
                        onKeyPress={(e) =>
                          !/[0-9]/.test(e.key) && e.preventDefault()
                        }
                      />
                    </InputGroup>
                    {errors.contact_no && (
                      <span className="text-danger">
                        {errors.contact_no.message}
                      </span>
                    )}
                  </Form.Group>
                </Col>

                {/* Email */}
                <Col md={6}>
                  <Form.Group className="main-form-section mt-3">
                    <Form.Label>Email</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="email"
                        placeholder="Enter Email Address"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value:
                              /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                            message: "Invalid Email Address",
                          },
                        })}
                        className={classNames({ "is-invalid": errors.email })}
                      />
                    </InputGroup>
                    {errors.email && (
                      <span className="text-danger">
                        {errors.email.message}
                      </span>
                    )}
                  </Form.Group>
                </Col>

                {/* Login Password */}
                <Col md={6}>
                  <Form.Group className="main-form-section mt-3">
                    <Form.Label>Login Password</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Login Password"
                        {...register("password", {
                          required: "Password is required",
                          pattern: {
                            value:
                              /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
                            message:
                              "Password must be 8+ chars with uppercase, number & symbol",
                          },
                        })}
                        className={classNames({
                          "is-invalid": errors.password,
                        })}
                      />
                      <InputGroup.Text
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? (
                          <EyeSlash size={18} />
                        ) : (
                          <Eye size={18} />
                        )}
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.password && (
                      <span className="text-danger">
                        {errors.password.message}
                      </span>
                    )}
                  </Form.Group>
                </Col>

                {/* Confirm Password */}
                <Col md={6}>
                  <Form.Group className="main-form-section mt-3">
                    <Form.Label>Confirm Password</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        {...register("c_password", {
                          required: "Confirm Password is required",
                          validate: (value) =>
                            value === watch("password") ||
                            "Passwords do not match",
                        })}
                        className={classNames({
                          "is-invalid": errors.c_password,
                        })}
                      />
                      <InputGroup.Text
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }>
                        {showConfirmPassword ? (
                          <EyeSlash size={18} />
                        ) : (
                          <Eye size={18} />
                        )}
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.c_password && (
                      <span className="text-danger">
                        {errors.c_password.message}
                      </span>
                    )}
                  </Form.Group>
                </Col>

                {/* His Share */}
                <Col md={6}>
                  <Form.Group className="main-form-section mt-3">
                    <Form.Label>His Share (%)</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="Enter His Share"
                        {...register("share", {
                          required: "His Share is required",
                          min: {
                            value: 0,
                            message: "Share cannot be negative",
                          },
                          max: {
                            value: 100,
                            message: "Share cannot exceed 100%",
                          },
                        })}
                        className={classNames({ "is-invalid": errors.share })}
                      />
                    </InputGroup>
                    {errors.share && (
                      <span className="text-danger">
                        {errors.share.message}
                      </span>
                    )}
                  </Form.Group>
                </Col>

                {/* Your Share */}
                <Col md={6}>
                  <Form.Group className="main-form-section mt-3">
                    <Form.Label>Your Share (%)</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="decimal"
                        disabled
                        placeholder="Your Share"
                        value={getValues("your_share") || ""}
                        {...register("your_share")}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              <div className="modal-footer-holder mt-4">
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      props.onHide();
                      reset();
                    }}>
                    Cancel
                  </Button>

                  {shimmerLoader ? (
                    <Loader
                      type="bubble-top"
                      bgColor="#FFF"
                      color="#FFF"
                      size={50}
                    />
                  ) : (
                    <Button variant="primary" type="submit">
                      Submit
                    </Button>
                  )}
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code !== 0}
      />
    </>
  );
}

export default Add;
